import axiosInstance from "../api/axiosInstance";

let appConfigCache = null;
let appConfigPromise = null;

export const getAppConfig = async () => {
  if (appConfigCache) {
    return appConfigCache;
  }

  if (!appConfigPromise) {
    appConfigPromise = axiosInstance
      .get("/admin/get-config")
      .then((response) => {
        appConfigCache = response?.data || {};
        return appConfigCache;
      })
      .finally(() => {
        appConfigPromise = null;
      });
  }

  return appConfigPromise;
};

export const clearAppConfigCache = () => {
  appConfigCache = null;
  appConfigPromise = null;
};
